
import { ElementContainer } from "../../../../library-js/dom-tools/ElementContainer";
import { RokojoriWebApp } from "./RokojoriWebApp";
import { RokojoriWebAppToolbar } from "./RokojoriWebAppToolbar";

export class RokojoriWebAppUI extends ElementContainer<Element>
{
  protected _app:RokojoriWebApp<any,any>;
  get webApp(){ return this._app }

  protected _toolbar:RokojoriWebAppToolbar;
  get toolbar(){ return this._toolbar; }

  constructor( e:Element, app:RokojoriWebApp<any,any> )
  {
    super();
    this._setElement( e as any );
    this._app = app;

    this._toolbar = new RokojoriWebAppToolbar( this.webApp );
    this.appendChild( this._toolbar );
    
  }
}